import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { StarIcon } from '../StarIcon';
type Props = {
  formattedRating: string;
  hideMaxRating?: boolean;
  reviewLink?: string | null;
  starIconColor?: string;
  starRating?: number;
};
export function StarRating(t0) {
  const $ = _c(13);
  const {
    formattedRating,
    hideMaxRating: t1,
    reviewLink,
    starIconColor,
    starRating
  } = t0;
  const hideMaxRating = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      gap: 1,
      alignItems: "center"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== starIconColor) {
    t3 = starIconColor && {
      color: starIconColor
    };
    $[1] = starIconColor;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <StarIcon {...t3} testid="rating-star-icon" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== formattedRating || $[6] !== hideMaxRating || $[7] !== reviewLink || $[8] !== starRating) {
    t5 = starRating ? <Box sx={{
      alignItems: "baseline"
    }}><Typography variant="bodyLargeBold" sx={{
        color: reviewLink ? "blues.main" : "common.black"
      }} data-testid="rating-actual">{formattedRating}</Typography>{!hideMaxRating && <Typography variant="bodySmall" color="text.secondary" sx={{
        marginLeft: 1
      }} data-testid="rating-maximum">/5</Typography>}</Box> : <Typography variant="bodySmall">Not yet rated</Typography>;
    $[5] = formattedRating;
    $[6] = hideMaxRating;
    $[7] = reviewLink;
    $[8] = starRating;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Box sx={t2}>{t4}{t5}</Box>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}